import { render } from "./SupportSponse.vue?vue&type=template&id=7328654a"
import script from "./SupportSponse.vue?vue&type=script&lang=js"
export * from "./SupportSponse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__